module.exports = __webpack_public_path__ + "static/media/new-members_top.86ad70e9.jpg";